export default __webpack_public_path__ + "static/media/cusano_logo.5bf95ac7.png";